export default __webpack_public_path__ + "static/buy-phone@2x-c9de9cbf3951df982170e63cbf83c267.png";